module.exports = __webpack_public_path__ + "static/img/clblog.16efa30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clblog.png
// module id = MwAx
// module chunks = 2